import { useState } from "react";
import {
  BlueButton,
  Modal,
  WhiteButton,
} from "@react-solutions-ui/findmore-ui";
import { completeOverdueEvaluationAsHr } from "../../../../services/evaluationsService";
import reportTableStyles from "../ReportTable/ReportTable.module.css";
import styles from "./HrCompletionComment.module.css";

type HrCompletionCommentProps = {
  evaluationId: string;
  onCompleted: () => Promise<void>;
};

export default function HrCompletionComment({
  evaluationId,
  onCompleted,
}: HrCompletionCommentProps) {
  const [comment, setComment] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);

  const handleConfirmSubmission = async () => {
    if (!comment.trim() || isSubmitting) return;

    try {
      setIsSubmitting(true);
      await completeOverdueEvaluationAsHr(evaluationId, comment.trim());
      await onCompleted();
      setIsConfirmationOpen(false);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div
        className={reportTableStyles.categorySection}
        aria-label="Comentário dos Recursos Humanos"
      >
        <div className={reportTableStyles.mobileCategoryHeader}>
          Comentário dos Recursos Humanos
        </div>
        <div className={reportTableStyles.tableWrapper}>
          <table className={reportTableStyles.table}>
            <thead>
              <tr>
                <th className={reportTableStyles.categoryHeader} colSpan={1}>
                  Comentário dos Recursos Humanos
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className={reportTableStyles.tableContentCell}>
                  <div className={styles.content}>
                    <textarea
                      className={styles.textarea}
                      value={comment}
                      onChange={(event) => setComment(event.target.value)}
                      placeholder="Escreve aqui o teu comentário..."
                      disabled={isSubmitting}
                    />
                    <div className={styles.actions}>
                      <WhiteButton
                        text="Cancelar"
                        onClick={() => setComment("")}
                        disabled={isSubmitting}
                      />
                      <BlueButton
                        text="Submeter comentário"
                        onClick={() => setIsConfirmationOpen(true)}
                        disabled={!comment.trim() || isSubmitting}
                      />
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {isConfirmationOpen && (
        <Modal
          title="Submeter comentário?"
          type="confirm"
          confirmActionLabel="Submeter"
          closeModalLabel="Cancelar"
          onConfirmAction={handleConfirmSubmission}
          onCloseModal={() => {
            if (!isSubmitting) setIsConfirmationOpen(false);
          }}
          isSending={isSubmitting}
        >
          <p className={styles.confirmationText}>
            Esta ação é definitiva. Não será possível editar o comentário e o relatório será finalizado.
          </p>
        </Modal>
      )}
    </>
  );
}
